import { IconButton, UtilityButton } from "@/components/elements/Button";
import WeldLogo from "@/components/elements/Weldlogo";
import { useHideGlobalBanners } from "@/components/modules/AppBanners";
import { WorkspaceSwitcher } from "@/components/modules/WorkspaceSwitcher";
import { useAuth0 } from "@auth0/auth0-react";

import { DestinationIcon } from "@/components/icons/domain-icons";
import { CollapsibleSidebar } from "../components/CollapsibleSidebar";
import { ConfettiRoot } from "../components/Confetti";

export default function SetupLayout(
  props: React.PropsWithChildren<{
    showWorkspaceSwitcher?: boolean;
  }>,
) {
  const { logout } = useAuth0();
  useHideGlobalBanners();
  return (
    <>
      <ConfettiRoot />
      <div className="absolute inset-0">
        <CollapsibleSidebar>
          <div className="relative flex h-full flex-col overflow-hidden bg-background">
            <div className="mt-8 pb-4">
              <WeldLogo className="mx-auto h-3 w-auto" />
              <div className="absolute top-2 right-2">
                {props.showWorkspaceSwitcher && (
                  <WorkspaceSwitcher>
                    <IconButton icon={<DestinationIcon className="size-5" />} />
                  </WorkspaceSwitcher>
                )}
              </div>
              <div className="absolute top-2 left-2 leading-none">
                <UtilityButton
                  type="button"
                  onClick={() =>
                    logout({
                      logoutParams: { returnTo: window.location.origin },
                    })
                  }
                  className="text-gray-300"
                >
                  Sign out
                </UtilityButton>
              </div>
            </div>
            <div className="flex flex-1 flex-col overflow-auto">
              <div className="h-full w-full">{props.children}</div>
            </div>
          </div>
        </CollapsibleSidebar>
      </div>
    </>
  );
}
